// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1HXI8","title":"card_title__1LvAh","inActive":"card_inActive__2jaej"};